module.exports = __webpack_public_path__ + "img/logo_skydome_login@2x.cec163a4.png";